<template>
  <div class="page-suspend">
    <div class="item" @click="$router.push('/query')">
      <span class="iconfont icon-dingdanchaxun"></span>
      <p>订单查询</p>
    </div>
    <div class="item" @click="announce">
      <span class="iconfont icon-gonggao1"></span>
      <p>网站公告</p>
    </div>
    <a :href="basic.help_qq" target="_blank">
      <div class="item">
        <span class="iconfont icon-lianxikefu"></span>
        <p>联系客服</p>
      </div>
    </a>
    <div class="item" v-show="topShow" @click="goTop">
      <span class="iconfont icon-fanhuidingbu"></span>
      <p>返回顶部</p>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  export default {
    props: ['text'],
    data() {
      return {
        name: this.text,
        topShow: false,
      }
    },
    computed: {
      ...mapState(["basic"])
    },
    mounted() {
      window.addEventListener("scroll", this.scrollToTop);
      if (this.basic.ggAuto == 1) {
        this.announce()
      }
    },
    methods: {
      // 网站公告
      announce() {
        this.$Modal.info({
          title: '网站公告',
          content: this.basic.announce ? this.basic.announce : '暂无公告'
        });
      },

      // 监听屏幕滚动
      scrollToTop() {
        var scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        if (scrollTop > 200) {
          this.topShow = true;

        } else {
          this.topShow = false;
        }
      },
      // 返回顶部
      goTop() {
        var timer = setInterval(function () {
          let osTop = document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
          if (osTop === 0) {
            clearInterval(timer);
          }
        }, 30)
      }
    }
  }
</script>

<style lang="less" scoped>
  .page-suspend {
    z-index: 1000;
    position: fixed;
    bottom: 65px;
    right: 30px;

    .item {
      width: 60px;
      height: 60px;
      background: rgba(0, 0, 0, 0.4);
      color: #ffffff;
      text-align: center;
      // line-height: 30px;
      margin-bottom: 10px;
      border-radius: 5px;
      cursor: pointer;

      .iconfont {
        font-size: 25px;
      }

      p {
        height: 15px;
        font-size: 10px;
      }
    }
  }
</style>